<template>
  <div class="upload-tool">
    <Upload
      :action="action"
      name="file"
      :format="imgFormat"
      :data="extraParams"
      :show-upload-list="false"
      :headers="headers"
      :max-size="5120"
      :on-progress="handleStart"
      :on-format-error="handleFormatError"
      :on-exceeded-size="handleImgMaxSize"
      :on-success="handleSuccess"
      :on-error="handleError"
      :before-upload="beforeUpload"
    >
      <Icon type="ios-videocam-outline" />
    </Upload>
    
  </div>
</template>

<script>
import StoreUtils from "@/utils/StoreUtils";
import conf from "@/views/im/conf";

export default {
  name: "upload-tool",
  data() {
    return {
      imgFormat: ["mp4"],
      fileFormat: [
        "doc",
        "docx",
        "jpg",
        "jpeg",
        "png",
        "gif",
        "xls",
        "xlsx",
        "pdf",
        "gif",
        "exe",
        "msi",
        "swf",
        "sql",
        "apk",
        "psd"
      ],
      tokenFile: {
        access_token: StoreUtils.getAccessToken(),
        type: "file"
      },
      action: conf.getHostUrl()+'/lazada/media/uploadVideo',
      extraParams: {},
      headers: {
        token: StoreUtils.getToken()
      }
    };
  },
  computed: {
    currentStore: {
      get: function () {
        return this.$store.state.lazada.currentStore;
      }
    }
  },
  methods: {
    beforeUpload(file) {
      console.log(file);
      this.extraParams = {
        store_id: this.currentStore.id
      }
      this.tokenFile = {
        access_token: StoreUtils.getAccessToken(),
        type: "file"
      };
      return new Promise(resolve => {
        this.$nextTick(function() {
          resolve(true);
        });
      });
    },

    // 错误提示
    openMessage(error) {
      this.$Message.error(error);
    },
    handleStart() {
      this.$Spin.show({
          render: (h) => {
              return h('div', [
                  h('Icon', {
                      'class': 'spin-icon-load',
                      props: {
                          type: 'ios-loading',
                          size: 18
                      }
                  }),
                  h('div', '视频上传中，请耐心等待...')
              ])
          }
      });
    },
    handleFormatError(file) {
      this.$Message.warning("文件 " + file.name + " 格式不正确。");
    },
    handleImgMaxSize(file) {
      this.$Message.warning("文件 " + file.name + " 太大，不能超过 512K！");
    },
    handleFileMaxSize(file) {
      this.$Message.warning("文件 " + file.name + " 太大，不能超过 10M！");
    },
    handleSuccess(res, file) {
      let self = this;
        console.log(res);
      if (res.code === 1) {
        console.log(file);
        //给父类传值
        self.$emit("uploadCallback", res.data);

        this.$Spin.hide();
      } else {
        this.$Message.error("文件上传错误，请重试");
      }
    },
    handleError: function() {
      this.$Spin.hide();
      this.$Message.error("上传错误！");
    }
  }
};
</script>

<style scoped>
.upload-tool {
  display: inline-block;
}
</style>
